@if ((site$ | async); as site) {
  <mat-card
    [style.border]=site.border (click)="onClickSelectSite(site)">
    <div class="card-status"
      [style.background-color]=site.backgroundColor
      [style.color]=site.textColor>
      <div style="display:flex; flex-direction:column">
        <div style="display:flex; flex-direction:row; justify-content: space-between; align-items: center">
          <div>{{site.name}}</div>
          @if ((advancedFeaturesAvailable$ | async)) {
            <div>
              <mat-icon matTooltip="{{'advanced_features_available' | transloco}}">design_services</mat-icon>
            </div>
          }
          @if ((advancedFeaturesActivating$ | async)) {
            <div
              matTooltip="{{'advanced_features_activating' | transloco}}">
              @if (site.status === siteStatus.INSTANCE_CREATING) {
                <mat-icon>clock_loader_10</mat-icon>
              }
              @if (site.status === siteStatus.INSTANCE_CREATED) {
                <mat-icon>clock_loader_20</mat-icon>
              }
              @if (site.status === siteStatus.INSTANCE_CONFIGURING) {
                <mat-icon>clock_loader_40</mat-icon>
              }
              @if (site.status === siteStatus.SERVICE_STARTING) {
                <mat-icon>clock_loader_60</mat-icon>
              }
              @if (site.status === siteStatus.SERVICE_CONFIGURED) {
                <mat-icon>clock_loader_80</mat-icon>
              }
              @if (site.status === siteStatus.INITIALIZING) {
                <mat-icon>clock_loader_90</mat-icon>
              }
            </div>
          }
        </div>
        @if (site.sector) {
          <div style="font-size: 10px">{{site | sector}}</div>
        }
      </div>
    </div>
    @if (hasDetections(site) || hasVolumes(site)) {
      <mat-divider></mat-divider>
      <mat-card-content class=modules>
        @if (hasDetections(site)) {
          <div>
            <detection-summary [detectionSummary]="site.detectionSummary"></detection-summary>
          </div>
        }
        @if (hasVolumes(site)) {
          <div class=module>
            <volume-summary [volumeSummary]="site.volumeSummary"></volume-summary>
          </div>
        }
      </mat-card-content>
    }
  </mat-card>
}
